/**!
 * Created by Leonardo Cheslacki on 29/02/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

const URI = 'https://gerenciador.toteminterativo.com.br/api/games-genius';
// const URI = 'http://gerenciador.local/api/games-genius';

module.exports.scene = {
    frame01: (_this) => {
        /**
         *
         * Class reference.
         */
        const
            AllTapClass = window.AllTap,
            current_name = 'index';

        /**
         *
         *  @param object
         *  Set "this", object of canvas CreateJs.
         */
        AllTapClass.setState({...AllTapClass.state, [`_this_${current_name}`]: _this}, () => {
            /**
             *
             *  Stop the movie clip in frame.
             */
            _this.gotoAndStop('frame01');
        });
    }
};

module.exports.symbol = {
    contentFrame01: {
        frame01: (_this) => {
            /**
             *
             * Class reference.
             */
            const
                AllTapClass = window.AllTap,
                current_name = 'frame01';

            AllTapClass.setState({...AllTapClass.state, [`_this_${current_name}`]: _this}, () => {
                const
                    _this_current = AllTapClass.state[`_this_${current_name}`],
                    {btn_submit, occ_button} = _this_current,
                    {_this_index} = AllTapClass.state,
                    occurrence = '03';

                const HelpersKeyboard = AllTapClass.$HelpersKeyboard({
                    current_name: current_name,
                    window: window,
                    names: [
                        'name',
                        'business',
                        'email'
                    ]
                });

                HelpersKeyboard.create();

                const submit = () => {
                    let spinner = null;

                    AllTapClass.postForm(URI, {genius: HelpersKeyboard.getFields()}, {
                        beforeSend: () => {
                            HelpersKeyboard.clearErrors();
                            occ_button.occ_text.visible = false;
                            btn_submit.visible = false;
                            spinner = AllTapClass.spinner(occ_button, '#282E3A');
                        },
                        done: ({status, data, errors}) => {
                            if (Boolean(status)) {
                                const {genius: {name, id}} = data;

                                AllTapClass.$jQuery('#_keyboard_').hide();

                                AllTapClass.state.data = {
                                    name: AllTapClass.toCapitalize(name).split(' ')[0],
                                    _id: id
                                };

                                HelpersKeyboard.clearFields();

                                _this_index.gotoAndStop(`frame${occurrence}`);
                                AllTapClass.effectFadeIn(_this_index, `occ_frame_${occurrence}`);
                            } else {
                                const {genius} = errors;
                                HelpersKeyboard.getErrors(genius);
                            }
                        },
                        fail: (response) => {
                            console.log(response);
                        },
                        always: () => {
                            occ_button.removeChild(spinner);
                            occ_button.occ_text.visible = true;
                            btn_submit.visible = true;
                        }
                    });
                };

                /**
                 *
                 *  Add event in the button for start.
                 */
                AllTapClass.removeListener('click', `btn-${current_name}-submit`, submit, () => {
                    AllTapClass.addListener(btn_submit, 'click', `btn-${current_name}-submit`, submit);
                });
            });
        }
    },
    contentFrame02: {
        frame01: (_this) => {
            /**
             *
             * Class reference.
             */
            const
                AllTapClass = window.AllTap,
                current_name = 'frame02';

            AllTapClass.setState({...AllTapClass.state, [`_this_${current_name}`]: _this}, () => {
                const
                    _this_current = AllTapClass.state[`_this_${current_name}`],
                    {_this_index} = AllTapClass.state,
                    occurrence = '03';

                const start = () => {
                    _this_index.gotoAndStop(`frame${occurrence}`);
                    AllTapClass.effectFadeIn(_this_index, `occ_frame_${occurrence}`);
                };

                /**
                 *
                 *  Add event in the button for start.
                 */
                AllTapClass.removeListener('click', `btn-${current_name}-start`, start, () => {
                    AllTapClass.addListener(_this_current.btn_start, 'click', `btn-${current_name}-start`, start);
                });
            });
        }
    },
    contentFrame03: {
        frame01: (_this) => {
            /**
             *
             * Class reference.
             */
            const
                AllTapClass = window.AllTap,
                current_name = 'frame03';

            AllTapClass.setState({...AllTapClass.state, [`_this_${current_name}`]: _this}, () => {
                const
                    {_this_index} = AllTapClass.state,
                    {occ_frame_04: {occ_name, occ_high_score}} = _this_index,
                    occurrence = '04';

                occ_name.font = `28px 'MontserratMedium'`;
                occ_name.y = (occ_name.y + 12);
                occ_high_score.font = `28px 'MontserratMedium'`;

                const GamesGenius = AllTapClass.$GamesGenius({
                    current_name: current_name
                });

                GamesGenius.create();

                GamesGenius.$objectResponse.always = ({high_score}) => {

                    AllTapClass.postForm(URI, {
                        genius: {
                            id: AllTapClass.state.data._id,
                            score: high_score
                        }
                    }, {
                        done: ({status, data, errors}) => {
                            if (Boolean(status)) {
                                occ_name.text = AllTapClass.state.data.name;

                                occ_high_score.text = high_score;

                                _this_index.gotoAndStop(`frame${occurrence}`);

                                AllTapClass.effectFadeIn(_this_index, `occ_frame_${occurrence}`, GamesGenius.$objectResponse.resolve);
                            } else {
                                console.log(errors);
                            }
                        },
                        fail: (response) => {
                            console.log(response);
                        },
                        always: () => {

                        }
                    });
                };
            });
        }
    },
    contentFrame04: {
        frame01: (_this) => {
            /**
             *
             * Class reference.
             */
            const
                AllTapClass = window.AllTap,
                current_name = 'frame04';

            AllTapClass.setState({...AllTapClass.state, [`_this_${current_name}`]: _this}, () => {
                const
                    _this_current = AllTapClass.state[`_this_${current_name}`],
                    {_this_index} = AllTapClass.state,
                    {occ_frame_04: {occ_name, occ_high_score}} = _this_index,
                    occurrence = '01';

                const back = () => {
                    occ_name.text = '';

                    occ_high_score.text = '0';

                    AllTapClass.$jQuery('#_keyboard_').show();

                    _this_index.gotoAndStop(`frame${occurrence}`);

                    AllTapClass.effectFadeIn(_this_index, `occ_frame_${occurrence}`);
                };

                /**
                 *
                 *  Add event in the button for start.
                 */
                AllTapClass.removeListener('click', `btn-${current_name}-back`, back, () => {
                    AllTapClass.addListener(_this_current.btn_back, 'click', `btn-${current_name}-back`, back);
                });
            });
        }
    }
};